import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.25 8.7a.55.55 0 1 0 0 1.1.55.55 0 0 0 0-1.1m-1.95.55a1.95 1.95 0 1 1 3.9 0 1.95 1.95 0 0 1-3.9 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 4.7a.7.7 0 0 1 .7-.7h16.6a.7.7 0 0 1 .7.7v14.6a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7zm1.4.7v9.834a10 10 0 0 1 1.806-1.141c1.322-.662 2.899-1.15 4.56-1.41 2.902-.453 6.159-.222 8.834 1.109V5.4zm15.2 9.986c-2.426-1.455-5.653-1.782-8.617-1.32-1.538.24-2.974.69-4.151 1.279-1.098.549-1.93 1.198-2.432 1.875v1.38h15.2z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ImageIcon24.js.map